import styles from "./Banner.module.scss";
import { BannerInt } from "interfaces";

const Banner = ({ title, subtitle, imgNav }: BannerInt) => {
  return (
    <section
      className={`${styles.banner} ${
        imgNav ? styles["img-nav"] : ""
      } anim-banner`}
    >
      <h2 className={`${styles.title} anim-banner-title`}>{title}</h2>
      {subtitle && (
        <p className={`xl ${styles.subtitle} anim-banner-subtitle`}>
          {subtitle}
        </p>
      )}
    </section>
  );
};

export default Banner;
